<template>
  <div :class="$style.container">
    <div :class="$style.block">
      <div :class="$style.row"><b>Дата создания:</b> {{ createDate }}</div>
      <div :class="$style.row"><b>Тип документа:</b> {{ notify.notify_name }}</div>
      <div :class="$style.row"><b>Тип и номер помещения:</b> {{ apartmentType.name }}, №{{ notify.apart_number }}
      </div>
    </div>

    <div :class="$style.block">
      <vs-button
        iconPack="feather"
        icon="icon-file"
        :class="$style.button"
        target="_blank"
        :href="notify.file_path | imgPath"
      >
        Открыть PDF на просмотр и печать
      </vs-button>
    </div>

<!--    <div :class="$style.block">-->
<!--      <div class=""><b>Квитанции с задолженностью:</b></div>-->
<!--      <div :key="debt.month" v-for="debt in notify.notify_params.months" :class="$style.item">-->
<!--        <span>{{ formatMonth(debt.month) }} - {{ debt.debt }}₽</span>-->
<!--      </div>-->
<!--    </div>-->

    <div :class="$style.block">
      <div class=""><b>Общая задолженность:</b></div>
      {{totalDebt}}₽
    </div>

    <div :class="$style.block">
      <div class=""><b>Рассчитанные статьи:</b></div>
      <div :key="i" v-for="(article, i) in notify.notify_params.articles" :class="$style.item">
        <span>{{ article.name }}</span> - {{ article.sum }}₽
      </div>
    </div>

    <!--    <div :class="$style.block">-->
    <!--      <div :class="$style.row">-->
    <!--        <b>Погасить задолженность до:</b>-->
    <!--        {{ dateDebtClose }}-->
    <!--        <span :class="$style.danger" v-if="isExpired">Просрочено</span>-->
    <!--      </div>-->
    <!--    </div>-->

    <div :class="$style.block">
      <div v-if="notify.notify_params.limit_services" :class="$style.row">
        <b>Ограничение услуг:</b> {{ notify.notify_params.limit_services[0].name }}
      </div>
      <div v-if="notify.notify_params.disable_services" :class="$style.row">
        <b>Приостановление услуг:</b> {{ notify.notify_params.disable_services[0].name }}
      </div>
    </div>

    <div :class="$style.block">
      <div :class="$style.row">
        <vs-checkbox v-model="notify.notify_params.payment_text" disabled>
          Выводить сообщение об оплате расходов
        </vs-checkbox>
      </div>
      <!--      <div :class="$style.row">-->
      <!--        <vs-checkbox v-model="notify.legal_entity_print" disabled>-->
      <!--          Добавить скан печати управляющей компании-->
      <!--        </vs-checkbox>-->
      <!--      </div>-->
      <!--      <div :class="$style.row">-->
      <!--        <vs-checkbox v-model="notify.legal_entity_signature" disabled>-->
      <!--          Добавить скан подписи генерального директора-->
      <!--        </vs-checkbox>-->
      <!--      </div>-->
    </div>

    <div :class="$style.block">
      <div :class="$style.row"><b>Внутренние комментарии</b></div>
      <vs-textarea :class="$style.comment" v-model="comment" />
      <div :class="$style.commentStatus" v-if="commentStatus">{{ commentStatus }}</div>
    </div>

    <div :class="$style.footer">
      <div :class="$style.block">
        <div :class="$style.row"><b>Действия</b></div>
      </div>

      <div v-if="notify.status === notifiesStatuses.enum.CANCEL" class="">
        <div :class="$style.row">Уведомление было отменено.</div>
        <div :class="$style.buttons">
          <vs-button
            type="border"
            :class="$style.button"
            iconPack="feather"
            icon="icon-rotate-ccw"
            @click="onComplete"
          >
            Восстановить
          </vs-button>
          <vs-button
            color="danger"
            type="border"
            :class="$style.button"
            iconPack="feather"
            icon="icon-trash"
            @click="onDelete"
          >
            Удалить навсегда
          </vs-button>
        </div>
      </div>

      <div v-if="notify.status === notifiesStatuses.enum.ACTIVE" class="">
        <div :class="$style.block">
          <div :class="$style.row">Если все оплаты пришли по уведомлению - завершите его.</div>
          <vs-button type="border" :class="$style.button" @click="onComplete">
            Завершить
          </vs-button>
        </div>

        <div :class="$style.row">
          Если нужно удалить уведомление, по которому еще есть задолженность — отмените его. Оно исчезнет из личного
          кабинета собственника, но останется в вашем списке.
        </div>
        <vs-button
          color="danger"
          type="border"
          :class="$style.button"
          @click="onCancel"
          iconPack="feather"
          icon="icon-trash"
        >
          Отменить
        </vs-button>
      </div>

      <div v-if="notify.status === notifiesStatuses.enum.COMPLETE" class="">
        <div :class="$style.block">
          <div :class="$style.row">Уведомление было завершено.</div>
          <vs-button
            type="border"
            :class="$style.button"
            iconPack="feather"
            icon="icon-rotate-ccw"
            @click="onRestore"
          >
            Отменить завершение
          </vs-button>
        </div>

        <div :class="$style.row">
          Если нужно удалить уведомление, по которому еще есть задолженность — отмените его. Оно исчезнет из личного
          кабинета собственника, но останется в вашем списке.
        </div>
        <vs-button
          color="danger"
          type="border"
          :class="$style.button"
          @click="onCancel"
          iconPack="feather"
          icon="icon-trash"
        >
          Отменить
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate          from "@/client/helpers/formatDate";
import * as apartmentTypes from "@/client/dictionaries/apartmentTypes";
import parseDate           from "@/client/helpers/parseDate";
import startOfDay          from "date-fns/startOfDay";
import notifiesStatuses    from "@/dictionaries/notifiesStatuses";
import mergeCommonErrors   from "@/helpers/mergeCommonErrors";
import modalContext        from "@/mixins/modalContext";
import notifyHttpError     from "@/mixins/notifyHttpError";
import currency            from 'currency.js';

export default {
  name:   "NotifiesEditPopup",
  props:  ['data'],
  mixins: [modalContext, notifyHttpError],
  data() {
    return {
      notify:             this.data,
      isSomethingChanged: false,
      comment:            this.data.notify_comment,
      commentStatus:      '',
      commentTimer:       null,
      notifiesStatuses,
    };
  },
  computed: {
    createDate() {
      return formatDate(this.notify.create_date);
    },
    dateDebtClose() {
      return formatDate(this.notify.notify_params.date_debt_close);
    },
    isExpired() {
      const now = startOfDay(new Date());

      return startOfDay(parseDate(this.notify.notify_params.date_debt_close)) < now;
    },
    apartmentType() {
      return apartmentTypes.getById(this.notify.type_apart);
    },

    totalDebt() {
      console.log(this.notify.notify_params);
      return this.notify.notify_params.months.reduce(( total, month ) => {
        return total.add(month.debt);
      }, currency(0)).toString();
    },
  },
  methods:  {
    formatMonth( date ) {
      return formatDate(date, 'LLLL yyyy');
    },

    updateNotify( data ) {
      this.isSomethingChanged = true;
      return this.$http.put(`notify/${this.notify.notify_id}`, {
        ...data,
        notify_comment: this.comment,
        buildings_id:   this.notify.building_id,
      }).then(( { data } ) => {
        this.notify = data;
      }).catch(this.notifyHttpError);
    },

    updateComment() {
      this.commentStatus = 'Сохранение...';
      if (this.commentTimer) clearTimeout(this.commentTimer);
      this.commentTimer = setTimeout(() => {
        this.commentTimer = null;
        this.updateNotify();
        this.commentStatus = 'Сохранено';
        setTimeout(() => this.commentStatus = null, 2000);
      }, 1000);
    },

    onRestore() {
      this.updateNotify({ notify_status: notifiesStatuses.enum.ACTIVE });
    },

    onComplete() {
      this.updateNotify({ notify_status: notifiesStatuses.enum.COMPLETE });
    },

    onCancel() {
      this.updateNotify({ notify_status: notifiesStatuses.enum.CANCEL });
    },

    onDelete() {
      this.$modal.openConfirm({
        message:  'Вы действительно хотите удалить уведомление?',
        onAccept: () => {
          return this.$http.delete(`notify/${this.notify.notify_id}`, { params: { buildings_id: this.notify.building_id } }).catch(e => {
            const errors = mergeCommonErrors(e.response.data, []);
            if (errors.common) this.$vs.notify({
              color: 'danger',
              time:  10000,
              title: 'Ошибка',
              text:  errors.common,
            });
          });
        },
      }).result.then(() => {
        this.isSomethingChanged = true;
        this.modalResolve();
      });
    },

    onBeforeClose() {
      return this.isSomethingChanged;
    },
  },
  mounted() {
    this.modalBeforeClose(this.onBeforeClose);
  },
  watch: {
    comment() {
      this.updateComment();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  font-size: 1.15em;
}

.row {
  margin-bottom: .25em;
}

.button {
  width: 100%;
  //margin: 1em 0;
}

.block {
  margin-bottom: 1em;
  position: relative;
}

.item {
  margin-top: .15em;

  span {
    font-weight: 500;
  }
}

.danger {
  font-weight: 500;
  color: color(danger);
}

.comment {
  textarea {
    height: 150px;
  }
}

.footer {
  border-top: 1px solid rgba(#000, .2);
  margin: 0 -1rem;
  padding: 1rem 1rem 0;
  font-size: .95em;
  line-height: 1.2;
}

.buttons {
  display: flex;
  margin: 0 -5px;

  > * {
    margin: 0 5px;
  }
}

.commentStatus {
  font-size: 1.05rem;
  position: absolute;
  right: 20px;
  bottom: 15px;
  opacity: .5;
  pointer-events: none;
}
</style>
